import React, { useState, useEffect } from 'react';
import {
  Form,
  Input,
  Button,
  message,
  Card,
  Row,
  Col,
  Avatar,
  Typography,
  Space,
  Skeleton,
  Divider,
  Badge,
  Tooltip,
} from 'antd';
import {
  UserOutlined,
  EditOutlined,
  CheckOutlined,
  CloseOutlined,
} from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import apiClient, { handleApiError } from '../utils/axiosConfig';

const { Title, Text } = Typography;

const EditProfile = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [profileData, setProfileData] = useState({});
  const [performanceData, setPerformanceData] = useState(null); // ✅ YENİ
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  const user = JSON.parse(localStorage.getItem('user'));
  const supplierId = user?.supplierId;

  useEffect(() => {
    if (supplierId) {
      fetchAllData(); // ✅ DEĞİŞTİ
    } else {
      message.error(t('user_not_found'));
      setLoading(false);
    }
  }, [supplierId]);

  // ✅ YENİ: Hem profil hem performans verilerini çek
  const fetchAllData = async () => {
    setLoading(true);
    try {
      // 1. Profil verilerini çek
      const profileResponse = await apiClient.get(`/api/Suppliers/${supplierId}`);
      const profile = profileResponse.data;
      setProfileData(profile);

      // 2. Performans verilerini çek
      try {
        const performanceResponse = await apiClient.get(
          `/api/SupplierPerformance/supplier/${supplierId}`
        );
        
        console.log('📊 Performance Data:', performanceResponse.data);

        // En son performans verisini al
        if (performanceResponse.data && performanceResponse.data.length > 0) {
          const latestPerformance = performanceResponse.data[0]; // İlk eleman en güncel
          setPerformanceData(latestPerformance);
        }
      } catch (perfError) {
        console.warn('Performance data fetch error:', perfError);
        setPerformanceData(null);
      }

      // Form'u doldur
      form.setFieldsValue({
        supplierName: profile.supplierName,
        category: profile.category,
        address: profile.address,
        businessContact: profile.businessContact,
        businessPhone: profile.businessPhone,
        location: profile.location,
      });
    } catch (error) {
      const errorMessage = handleApiError(error, t('failed_to_fetch_profile'));
      message.error(errorMessage);
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  const onFinish = async (values) => {
    setUpdating(true);

    const updatePayload = {
      supplierName: values.supplierName,
      category: values.category,
      address: values.address,
      businessContact: values.businessContact,
      businessPhone: values.businessPhone,
      location: values.location,
    };

    try {
      await apiClient.put(`/api/Suppliers/${supplierId}/profile`, updatePayload);

      message.success(t('profile_update_successful'));
      setIsEditing(false);

      await fetchAllData(); // ✅ DEĞİŞTİ

      const updatedUser = {
        ...user,
        supplierName: values.supplierName,
      };
      localStorage.setItem('user', JSON.stringify(updatedUser));
    } catch (error) {
      const errorMessage = handleApiError(error, t('profile_update_failed'));
      message.error(errorMessage);
      console.error('Error updating profile:', error);
    } finally {
      setUpdating(false);
    }
  };

  if (loading) {
    return (
      <div style={{ padding: '40px 24px', backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <Card
            style={{
              borderRadius: '16px',
              border: 'none',
              boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
            }}
          >
            <Skeleton active paragraph={{ rows: 10 }} />
          </Card>
        </div>
      </div>
    );
  }

  return (
    <div style={{ padding: '40px 24px', backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        {/* Header Section */}
        <div
          style={{
            background: 'white',
            borderRadius: '16px',
            padding: '32px',
            marginBottom: '24px',
            border: 'none',
            boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
          }}
        >
          <Row align="middle" justify="space-between" gutter={[24, 24]}>
            <Col xs={24} md={16}>
              <Space size={24} align="start">
                <Badge
                  dot
                  status="success"
                  offset={[-8, 64]}
                  style={{ width: 12, height: 12 }}
                >
                  <Avatar
                    size={72}
                    style={{
                      backgroundColor: '#1a1a1a',
                      fontSize: '28px',
                      fontWeight: '600',
                    }}
                  >
                    {profileData.supplierName?.charAt(0)?.toUpperCase()}
                  </Avatar>
                </Badge>
                <div>
                  <Title
                    level={3}
                    style={{
                      margin: 0,
                      marginBottom: '8px',
                      color: '#1a1a1a',
                      fontWeight: '600',
                      fontSize: '24px',
                    }}
                  >
                    {profileData.supplierName}
                  </Title>
                  <Space size={12}>
                    <Text
                      style={{
                        fontSize: '14px',
                        color: '#8c8c8c',
                        fontWeight: '500',
                      }}
                    >
                      {profileData.supplierCode}
                    </Text>
                    {profileData.category && (
                      <>
                        <span style={{ color: '#d9d9d9' }}>•</span>
                        <Text
                          style={{
                            fontSize: '14px',
                            color: '#595959',
                            fontWeight: '500',
                          }}
                        >
                          {profileData.category}
                        </Text>
                      </>
                    )}
                  </Space>
                </div>
              </Space>
            </Col>
            <Col xs={24} md={8} style={{ textAlign: 'right' }}>
              {!isEditing ? (
                <Button
                  type="primary"
                  size="large"
                  icon={<EditOutlined />}
                  onClick={() => setIsEditing(true)}
                  style={{
                    height: '44px',
                    borderRadius: '8px',
                    fontWeight: '500',
                    fontSize: '15px',
                    background: '#1a1a1a',
                    border: 'none',
                    paddingLeft: '24px',
                    paddingRight: '24px',
                  }}
                >
                  {t('edit_profile')}
                </Button>
              ) : (
                <Space size={12}>
                  <Button
                    size="large"
                    icon={<CloseOutlined />}
                    onClick={() => {
                      setIsEditing(false);
                      form.resetFields();
                    }}
                    style={{
                      height: '44px',
                      borderRadius: '8px',
                      fontWeight: '500',
                      fontSize: '15px',
                      border: '1px solid #d9d9d9',
                    }}
                  >
                    {t('cancel')}
                  </Button>
                  <Button
                    type="primary"
                    size="large"
                    icon={<CheckOutlined />}
                    onClick={() => form.submit()}
                    loading={updating}
                    style={{
                      height: '44px',
                      borderRadius: '8px',
                      fontWeight: '500',
                      fontSize: '15px',
                      background: '#1a1a1a',
                      border: 'none',
                      paddingLeft: '24px',
                      paddingRight: '24px',
                    }}
                  >
                    {t('save_changes')}
                  </Button>
                </Space>
              )}
            </Col>
          </Row>
        </div>

        {/* Main Form */}
        <div
          style={{
            background: 'white',
            borderRadius: '16px',
            padding: '40px',
            border: 'none',
            boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
          }}
        >
          <Form form={form} layout="vertical" onFinish={onFinish} disabled={!isEditing}>
            {/* Company Information */}
            <div style={{ marginBottom: '40px' }}>
              <Title
                level={5}
                style={{
                  margin: 0,
                  marginBottom: '24px',
                  color: '#1a1a1a',
                  fontWeight: '600',
                  fontSize: '16px',
                }}
              >
                {t('company_information')}
              </Title>

              <Row gutter={[24, 24]}>
                <Col xs={24} md={12}>
                  <Form.Item
                    label={
                      <Text
                        style={{
                          fontSize: '14px',
                          fontWeight: '500',
                          color: '#595959',
                        }}
                      >
                        {t('supplier_name')}
                      </Text>
                    }
                    name="supplierName"
                    rules={[
                      { required: true, message: t('please_enter_supplier_name') },
                    ]}
                  >
                    <Input
                      placeholder={t('enter_supplier_name')}
                      style={{
                        height: '44px',
                        borderRadius: '8px',
                        fontSize: '15px',
                        border: '1px solid #e0e0e0',
                      }}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12}>
                  <Form.Item
                    label={
                      <Text
                        style={{
                          fontSize: '14px',
                          fontWeight: '500',
                          color: '#595959',
                        }}
                      >
                        {t('category')}
                      </Text>
                    }
                    name="category"
                  >
                    <Input
                      placeholder={t('enter_category')}
                      style={{
                        height: '44px',
                        borderRadius: '8px',
                        fontSize: '15px',
                        border: '1px solid #e0e0e0',
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </div>

            <Divider style={{ margin: '40px 0' }} />

            {/* Location Information */}
            <div style={{ marginBottom: '40px' }}>
              <Title
                level={5}
                style={{
                  margin: 0,
                  marginBottom: '24px',
                  color: '#1a1a1a',
                  fontWeight: '600',
                  fontSize: '16px',
                }}
              >
                {t('location_information')}
              </Title>

              <Row gutter={[24, 24]}>
                <Col xs={24}>
                  <Form.Item
                    label={
                      <Text
                        style={{
                          fontSize: '14px',
                          fontWeight: '500',
                          color: '#595959',
                        }}
                      >
                        {t('address')}
                      </Text>
                    }
                    name="address"
                  >
                    <Input.TextArea
                      rows={4}
                      placeholder={t('enter_detailed_address')}
                      style={{
                        borderRadius: '8px',
                        fontSize: '15px',
                        border: '1px solid #e0e0e0',
                      }}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12}>
                  <Form.Item
                    label={
                      <Text
                        style={{
                          fontSize: '14px',
                          fontWeight: '500',
                          color: '#595959',
                        }}
                      >
                        {t('location')}
                      </Text>
                    }
                    name="location"
                  >
                    <Input
                      placeholder={t('enter_city_country')}
                      style={{
                        height: '44px',
                        borderRadius: '8px',
                        fontSize: '15px',
                        border: '1px solid #e0e0e0',
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </div>

            <Divider style={{ margin: '40px 0' }} />

            {/* Contact Information */}
            <div>
              <Title
                level={5}
                style={{
                  margin: 0,
                  marginBottom: '24px',
                  color: '#1a1a1a',
                  fontWeight: '600',
                  fontSize: '16px',
                }}
              >
                {t('contact_information')}
              </Title>

              <Row gutter={[24, 24]}>
                <Col xs={24} md={12}>
                  <Form.Item
                    label={
                      <Text
                        style={{
                          fontSize: '14px',
                          fontWeight: '500',
                          color: '#595959',
                        }}
                      >
                        {t('business_contact_name')}
                      </Text>
                    }
                    name="businessContact"
                  >
                    <Input
                      placeholder={t('enter_contact_person_name')}
                      style={{
                        height: '44px',
                        borderRadius: '8px',
                        fontSize: '15px',
                        border: '1px solid #e0e0e0',
                      }}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12}>
                  <Form.Item
                    label={
                      <Text
                        style={{
                          fontSize: '14px',
                          fontWeight: '500',
                          color: '#595959',
                        }}
                      >
                        {t('business_phone')}
                      </Text>
                    }
                    name="businessPhone"
                  >
                    <Input
                      placeholder={t('enter_phone_number_with_country_code')}
                      style={{
                        height: '44px',
                        borderRadius: '8px',
                        fontSize: '15px',
                        border: '1px solid #e0e0e0',
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </div>
          </Form>
        </div>

        {/* ✅ Statistics Cards - GÜNCELLENMIŞ */}
        <Row gutter={[24, 24]} style={{ marginTop: '24px' }}>
          <Col xs={24} sm={8}>
            <div
              style={{
                background: 'white',
                borderRadius: '16px',
                padding: '32px',
                textAlign: 'center',
                border: 'none',
                boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
              }}
            >
              <div
                style={{
                  fontSize: '32px',
                  fontWeight: '700',
                  color: '#1a1a1a',
                  marginBottom: '8px',
                }}
              >
                {profileData.certificates?.length || 0}
              </div>
              <Text
                style={{
                  fontSize: '14px',
                  color: '#8c8c8c',
                  fontWeight: '500',
                }}
              >
                {t('certificates')}
              </Text>
            </div>
          </Col>

          <Col xs={24} sm={8}>
            <div
              style={{
                background: 'white',
                borderRadius: '16px',
                padding: '32px',
                textAlign: 'center',
                border: 'none',
                boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
              }}
            >
              <div
                style={{
                  fontSize: '32px',
                  fontWeight: '700',
                  color: '#1a1a1a',
                  marginBottom: '8px',
                }}
              >
                {performanceData?.supplierClass || '-'}
              </div>
              <Text
                style={{
                  fontSize: '14px',
                  color: '#8c8c8c',
                  fontWeight: '500',
                }}
              >
                {t('supplier_level')}
              </Text>
            </div>
          </Col>

          <Col xs={24} sm={8}>
            <div
              style={{
                background: 'white',
                borderRadius: '16px',
                padding: '32px',
                textAlign: 'center',
                border: 'none',
                boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
              }}
            >
              <div
                style={{
                  fontSize: '32px',
                  fontWeight: '700',
                  color: '#1a1a1a',
                  marginBottom: '8px',
                }}
              >
                {performanceData?.totalScore?.toFixed(1) || '-'}
              </div>
              <Text
                style={{
                  fontSize: '14px',
                  color: '#8c8c8c',
                  fontWeight: '500',
                }}
              >
                {t('performance_score')}
              </Text>
            </div>
          </Col>
        </Row>
      </div>

      <style jsx>{`
        .ant-input:focus,
        .ant-input:hover,
        .ant-input-focused {
          border-color: #1a1a1a !important;
          box-shadow: 0 0 0 2px rgba(26, 26, 26, 0.05) !important;
        }

        .ant-input-disabled {
          background: #fafafa !important;
          border-color: #e0e0e0 !important;
          color: #595959 !important;
        }
      `}</style>
    </div>
  );
};

export default EditProfile;
